module.exports = __webpack_public_path__ + "static/media/pasamosagosto2.ee0f4d10.webp";